import { Injectable, inject } from '@angular/core';
import { StateDeclaration, Transition, UIRouter } from '@uirouter/core';

@Injectable({
  providedIn: 'root',
})
export class TransitionService {
  private readonly uiRouter = inject(UIRouter);

  private isScrollToTopEnabled = true;
  private isScrollToTopSuspended = false;

  constructor() {}

  hookTransitionEvents() {
    const transitionService = this.uiRouter.transitionService;
    transitionService.onSuccess({}, () => this.onSuccess());
    transitionService.onEnter({}, (transition, state) => this.onEnter(transition, state));
  }

  private onSuccess() {
    if (this.isScrollToTopSuspended) {
      this.isScrollToTopSuspended = false;
      return;
    }

    if (!this.isScrollToTopEnabled) return;

    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }

  private onEnter(transition: Transition, state: StateDeclaration) {
    if (state.data?.documentTitle) document.title = state.data?.documentTitle;
  }

  disableScrollToTop() {
    this.isScrollToTopEnabled = false;
  }

  enableScrollToTop() {
    this.isScrollToTopEnabled = true;
  }

  // suspend for a single transition
  suspendScrollToTop() {
    this.isScrollToTopSuspended = true;
  }
}
